module.exports = __webpack_public_path__ + "img/gear-blue.82540067.png";